"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import UiForm, { UiFormAnnotations, UiFormController } from "@/components/form/UiForm.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import i18n from "@/lang";
export class BindIpByVdForm extends UiFormController {
  constructor() {
    super(...arguments);
    this.ip = "";
    this.ip_mode = "FIIXED";
  }
}
__decorateClass([
  UiFormAnnotations.Rule([{
    required: true,
    message: i18n.t("bindipbyvddialog.please_fill_in"),
    trigger: "blur"
  }])
], BindIpByVdForm.prototype, "ip", 2);
__decorateClass([
  UiFormAnnotations.Rule([{
    required: true,
    message: i18n.t("bindipbyvddialog.please_select"),
    trigger: "blur"
  }])
], BindIpByVdForm.prototype, "ip_mode", 2);
let BindIpByVdDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.row = {};
    this.dialogLoading = false;
    this.dialog = new UiDialogController();
    this.controller = new BindIpByVdForm();
    this.reallyIp = "";
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  submit() {
    return __async(this, null, function* () {
      try {
        yield this.$confirm(this.$t("bindipbyvddialog.revised_tip"), this.$t("bindipbyvddialog.revised"), {
          confirmButtonText: this.$t("bindipbyvddialog.determine"),
          cancelButtonText: this.$t("bindipbyvddialog.cancel"),
          type: "warning"
        }).then(() => __async(this, null, function* () {
          try {
            yield API.post(`api://base.auth.pro/v1/virtual-desktops/${this.row.id}/local`, {
              "ip": this.controller.ip,
              "ipMode": this.controller.ip_mode
            });
            this.$message.success(this.$t("bindipbyvddialog.bind_local"));
            this.close();
          } catch (error) {
            if (error.hasOwnProperty("response")) {
              this.$message.error(error.response.data.errors.datas[0].message);
            }
          }
        })).catch(() => {
          return;
        });
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  getReallyIp() {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(`api://base.auth/api/v1/accounts/ip`);
        if (response.data.account_ip) {
          this.reallyIp = response.data.account_ip.ip;
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  getInfo() {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(`api://base.auth.pro/v1/virtual-desktops/${this.row.id}/local`);
        this.controller.ip = response.data.ip;
        this.controller.ip_mode = response.data.ipMode;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  open(row) {
    this.row = row;
    this.controller = new BindIpByVdForm();
    this.getInfo();
    this.getReallyIp();
    this.dialog.visible = true;
  }
  close() {
    this.dialog.visible = false;
    this.$emit("refresh");
  }
};
BindIpByVdDialog = __decorateClass([
  Component({
    components: {
      UiForm,
      UiSubmit,
      UiDialog
    }
  })
], BindIpByVdDialog);
export {
  BindIpByVdDialog as default
};
